export default __webpack_public_path__ + "static/media/promission-bootstrap.09fc950d.png";